import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BackendService } from 'src/app/services/backend.service';


@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
    isActive: boolean;
    collapsed: boolean;
    showMenu: string;
    pushRightClass: string;
    private querySubscription;
    admin;
    errorMessage: String = '';
    error = false;
    showMenus: boolean;
    noshowMenus: boolean;

    dataLoading = false;


    @Output() collapsedEvent = new EventEmitter<boolean>();

    constructor(private translate: TranslateService, public router: Router, private backendService: BackendService) {
        this.translate.addLangs(['es', 'pt']);
        this.translate.use(window.localStorage.getItem('idioma'));
        console.log('Creando sidebar');

        this.router.events.subscribe(val => {
            if (
                val instanceof NavigationEnd &&
                window.innerWidth <= 992 &&
                this.isToggled()
            ) {
                this.toggleSidebar();
            }
        });

    }

    userAdmin() {
        this.admin = window.localStorage.getItem('admin');
    }

    ngOnInit() {
        console.log('Cargando sidebar');
        this.userAdmin();
        console.log ('Es admin?');
        console.log (this.admin);
        this.isAdmin();
        this.isActive = false;
        this.collapsed = false;
        this.showMenu = '';
        this.pushRightClass = 'push-right';
    }

    isAdmin() {
        console.log('Cargando vista');
        if (this.admin === '0' || this.admin === 0) {
            console.log('Mostrando admin');
            this.showMenus = true;
            this.noshowMenus = false;
        }
        if (this.admin === '1' || this.admin === 1) {
            console.log('Mostrando no admin');
            this.showMenus = false;
            this.noshowMenus = true;
        }
    }


    eventCalled() {
        this.isActive = !this.isActive;
    }

    addExpandClass(element: any) {
        if (element === this.showMenu) {
            this.showMenu = '0';
        } else {
            this.showMenu = element;
        }
    }

    toggleCollapsed() {
        this.collapsed = !this.collapsed;
        this.collapsedEvent.emit(this.collapsed);
    }

    isToggled(): boolean {
        const dom: Element = document.querySelector('body');
        return dom.classList.contains(this.pushRightClass);
    }

    toggleSidebar() {
        const dom: any = document.querySelector('body');
        dom.classList.toggle(this.pushRightClass);
    }

    rltAndLtr() {
        const dom: any = document.querySelector('body');
        dom.classList.toggle('rtl');
    }

    changeLang(language: string) {
        this.translate.use(language);
        window.localStorage.removeItem('idioma');
        window.localStorage.setItem('idioma', language);
    }

    onLoggedout() {
        localStorage.removeItem('token');
        localStorage.removeItem('idioma');
        this.router.navigate(['../login']);
    }

    usuario() {
        this.router.navigate(['/layout/blank-page']);
    }

    instituciones() {
        this.router.navigate(['/layout/instituciones']);

    }

    lugares() {
        this.router.navigate(['/layout/lugares']);
    }

    ciudadano() {
        this.router.navigate(['/layout/ciudadano']);
    }

    iniciarFormulario() {
        this.router.navigate(['/layout/encs']);
    }

    dashboard() {
        this.router.navigate(['/layout']);
    }

    historial() {
        this.router.navigate(['/layout/historial']);
    }

    export() {
        this.router.navigate(['/layout/export']);
    }

    mmse() {
        this.router.navigate(['/layout/minimental']);
    }

    bls() {
        this.router.navigate(['/layout/blessed']);
    }

    earvi() {
        this.router.navigate(['/layout/earvi']);
    }

    ucla() {
        this.router.navigate(['/layout/ucla']);
    }
    esc() {
        this.router.navigate(['/layout/esc']);
    }
    naci() {
        this.router.navigate(['/layout/naci']);
    }
    pnaci() {
        this.router.navigate(['/layout/pnaci']);
    }
    escalasocial() {
        this.router.navigate(['/layout/escalasocial']);
    }
    gds() {
        this.router.navigate(['/layout/gds']);
    }
    panas() {
        this.router.navigate(['/layout/panas']);
    }
    whoqol() {
        this.router.navigate(['/layout/whoqol']);
    }
}
